import styled from 'styled-components';

const Error = styled.p`
  color: var(--error-600);
  font-size: 0.9rem;
`;
export default Error;
